import { Profile } from '../global-state/types';
import { commonTranslations } from '../translations';

export const permissionTypes = ['C', 'R', 'U', 'D'] as const;
export type PermissionType = (typeof permissionTypes)[number];

export const permissionTypeMapping: { [key in PermissionType]: { key: string; defaultValue: string } } = {
  C: commonTranslations.create,
  R: commonTranslations.read,
  U: commonTranslations.update,
  D: commonTranslations.delete,
};

export const getSuamRoles = (userProfile: Profile, currentStoreId: string) => {
  const suamRoles =
    userProfile.assignments
      ?.filter(({ locationCode }) => locationCode === currentStoreId)
      .map(({ suamRoleCode }) => suamRoleCode) || [];
  return suamRoles;
};
